import { CardContainer } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

const CARD_MAX_WIDTH = 966;
const BANNER_HEIGHT = 108;
// StepLayout horizontal padding (24px) + PairScreenModalBody padding (24px)
// must be escaped on each side for the gradient to bleed to the modal edges.
const BANNER_BLEED = 48;

export const StepLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  width: 100%;
  padding: 24px;
`;

export const ScreenChoiceCard = styled(CardContainer)`
  width: 100%;
  max-width: ${CARD_MAX_WIDTH}px;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  cursor: default;

  &:hover {
    background: var(--color-white-100, #fff);
  }
`;

export const ScreenChoiceCardLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 310px;
`;

export const StepTitle = styled.h2`
  margin: 0;
  font-family: Lato, sans-serif;
  font-weight: 900;
  font-size: 24px;
  line-height: 36px;
  color: #19191b;
`;

export const StepHelper = styled.p`
  margin: 0;
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #404145;
`;

export const StepperRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
`;

export interface StepperButtonProps {
  $position: "start" | "end";
}

export const StepperButton = styled.button<StepperButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 44px;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  color: #19191b;
  border-radius: ${({ $position }) =>
    $position === "start" ? "8px 0 0 8px" : "0 8px 8px 0"};

  &:disabled {
    background: #eee;
    cursor: not-allowed;
  }
`;

export const ScreenDisplay = styled.div`
  position: relative;
  width: 380px;
  height: 222px;
  background: #19191b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Lato, sans-serif;
  font-weight: 900;
  font-size: 56px;
  line-height: 56px;
  color: #fff;
`;

export const BannerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% + ${BANNER_BLEED * 2}px);
  height: ${BANNER_HEIGHT}px;
  margin: 0 -${BANNER_BLEED}px;
  background: linear-gradient(to bottom, #d2cbff, #ece7ff);
  overflow: visible;
`;

export const BannerContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${CARD_MAX_WIDTH}px;
  height: 100%;
  padding: 0 40px;
`;

export const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Lato, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #19191b;
`;

export const BannerImage = styled.img`
  position: absolute;
  right: 80px;
  top: -35px;
  height: 160px;
  width: auto;
  pointer-events: none;
`;

export const PixiInlineLogo = styled.img`
  display: inline-block;
  height: 14px;
  width: auto;
  vertical-align: baseline;
  margin: 0 2px;
`;
